import React, { Suspense } from 'react';
import './App.css';
import { Theme } from '@vdx/tiles/theme';

const Loading = React.lazy(() => import('./Loading'));
const AppRouter = React.lazy(() => import('./AppRouter'));

const App = () => (
  <Theme>
    <Suspense fallback={<Loading />}>
      <AppRouter />
    </Suspense>
  </Theme>
);

export default App;
